import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

export const AI_CONSENT_TITLE = 'Use AI to create your movie picks?';
export const AI_CONSENT_BODY =
  'MovieMe sends OpenAI your recommendation choices—mood or genres, favorite movie titles, critical-acclaim choice, and time period—plus titles you’ve marked Watched. OpenAI uses them to generate picks and avoid repeats.';
export const AI_CONSENT_REASSURANCE =
  'AI recommendations can’t work unless you allow this. MovieMe does not send your email address or Watchlist to OpenAI.';
export const AI_CONSENT_ALLOW = 'Allow and show my picks';
export const AI_CONSENT_NOT_NOW = 'Not now';
export const AI_CONSENT_SAVE_ERROR =
  'Couldn’t save your choice. Check your connection and try again.';

type Props = {
  saving?: boolean;
  error?: string | null;
  onAllow: () => void;
  onNotNow: () => void;
};

export function AIRecommendationConsentSheet({
  saving = false,
  error = null,
  onAllow,
  onNotNow,
}: Props) {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <div className="mx-auto w-full max-w-md px-1 pb-[max(1rem,env(safe-area-inset-bottom))] pt-4">
      <section
        className="cine-card animate-rise space-y-5 rounded-2xl p-6 sm:p-8"
        role="dialog"
        aria-modal="true"
        aria-labelledby="ai-consent-title"
        aria-describedby="ai-consent-body"
      >
        <div className="space-y-3">
          <h2 id="ai-consent-title" className="display text-2xl font-semibold outline-none" tabIndex={-1} ref={titleRef}>
            {AI_CONSENT_TITLE}
          </h2>
          <p id="ai-consent-body" className="text-sm leading-relaxed text-muted-foreground">
            {AI_CONSENT_BODY}
          </p>
          <p className="text-sm leading-relaxed text-muted-foreground">{AI_CONSENT_REASSURANCE}</p>
        </div>

        {error ? (
          <p className="text-sm text-red-300" role="alert">
            {error}
          </p>
        ) : null}

        <div className="flex flex-col gap-3">
          <button
            type="button"
            className="btn-marquee min-h-[44px] w-full px-6 py-3"
            disabled={saving}
            onClick={onAllow}
          >
            {saving ? 'Saving…' : AI_CONSENT_ALLOW}
          </button>
          <button
            type="button"
            className="btn-ghost min-h-[44px] w-full px-6 py-3"
            disabled={saving}
            onClick={onNotNow}
          >
            {AI_CONSENT_NOT_NOW}
          </button>
          <Link
            to="/privacy"
            className="inline-flex min-h-[44px] items-center justify-center text-sm text-foreground/80 underline-offset-4 hover:text-white hover:underline"
          >
            Privacy Policy
          </Link>
        </div>
      </section>
    </div>
  );
}
